import React from "react";
import "../../Assets/SCSS/components/Pageheader.scss";

const CallOutNew = ({
  header = "",
  emoji = "",
  classnames = "",
  textcolor = "",
}) => (
  <div className={`call-out-wrapper ${classnames}`}>
    <p className="floatleft margin-right-8 t-12 margin-top-0 margin-bottom-0">
      {emoji}
    </p>
    <p className="extra-small-blue floatleft" style={{ color: `${textcolor}` }}>
      {header}
    </p>
  </div>
);

export default CallOutNew;
